﻿import { isGuid } from '../../../../../DanskeSpil/Domain/Feature.Casino/Scripts/Types';

export const getUrlWithoutParameters = (url?: string) => (url ?? location.href).split(/[?#]/)[0];

export const addAnchor = (anchor: string | null) => (anchor ? `#${anchor}` : '');

export const getParameter = (key: string, queryString?: string) => {
  // if queryString not defined, use current location URL
  if (!queryString) {
    queryString = window.location.search.substring(1);
  }

  const params = queryString.split('&');

  for (const param of params) {
    const args = param.split('=');
    if (args[0] === key) {
      return decodeURIComponent(args[1] ?? args[0]);
    }
  }

  return '';
};

export const getAnchor = (acceptOnlyGuid : boolean = false) => {
  if (acceptOnlyGuid && !isGuid(window.location.hash.substring(1))) {
    return '';
  }
  return window.location.hash;
};


export const removeParameterAutomatically = (queryKey: string) => {
  const modifiedUrl = removeParameter(queryKey);
  history.replaceState(null, document.title, modifiedUrl);
  document.dispatchEvent(new CustomEvent('danskespil:locationChanged', { detail: { queryKey, state: 'removed' } }));
};

export const removeParameter = (queryKey: string, url?: string) => {
  if (typeof url === 'undefined') {
    url = location.href;
  }
  const [href, searchParams] = url.includes('?') ? url.split('?') : [url, ''];
  const existing = searchParams.split('&');

  let hashValue = '';
  const urlParams = existing
    .filter((keyVal) => {
      const [key, value] = keyVal.split('=');
      if (key.includes('#')) {
        const [hashKey, hash] = key.split('#');
        if (hashKey === queryKey) {
          hashValue = `#${hash}`;
          return false;
        }
      }
      return key !== queryKey;
    })
    .join('&');

  const finalUrlParams = urlParams + hashValue;
  return href + (urlParams ? `?${finalUrlParams}` : hashValue);
};

export const appendParameterAutomatically = (queryKey: string, queryValue?: string) => {
  const modifiedUrl = appendParameter(queryKey, queryValue, window.location.search);
  history.replaceState(null, document.title, location.pathname + modifiedUrl + location.hash);
  document.dispatchEvent(new CustomEvent('danskespil:locationChanged', { detail: { queryKey, queryValue, state: 'added' } }));
};

export const appendParameters = function (params: Array<string[]>, url?: string) {
  let modifiedUrl = url;

  for (const [key, value] of params) {
    modifiedUrl = appendParameter(key, value, modifiedUrl);
  }

  return modifiedUrl;
};

export const appendParameter = function (queryKey: string, queryValue?: string, url?: string) {

  if (typeof url === 'undefined') {
    url = window.location.href;
  }

  url = removeParameter(queryKey, url);

  let [modifiedUrl, hashRoute] = url.split('#');
  const existingParams = modifiedUrl.includes('?');
  modifiedUrl += (existingParams ? '&' : '?') + queryKey + (queryValue ? '=' + encodeURIComponent(queryValue) : '') + (hashRoute ? `#${hashRoute}` : '');

  return modifiedUrl;
};
